import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import WorkbenchTestView from "../views/WorkbenchTestView.vue";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeView
    },
    {
      path: "/workbench-test",
      name: "workbench-test",
      component: WorkbenchTestView
    }
  ]
});
